import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "microsoft-teams",
  "name": "Microsoft Teams",
  "category": "integrations",
  "description": "Interact with Microsoft Teams via Microsoft Graph API - send messages, create channels, manage members, schedule meetings, and more",
  "icon": "microsoft-teams",
  "iconType": "microsoft-icon",
  "color": "purple",
  "version": "2.0.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "Microsoft Teams",
    "color": "#6264a7"
  },
  "credentials": [
    {
      "name": "microsoft_teams_oauth",
      "required": false,
      "displayName": "Microsoft Teams OAuth2",
      "displayOptions": {
        "show": {
          "useCredential": [true]
        }
      }
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "microsoft",
    "teams",
    "chat",
    "message",
    "collaboration",
    "microsoft-graph",
    "channels",
    "adaptive-cards",
    "meetings"
  ],
  "comingSoon": false
};

export default definition;
